<template>
    <div v-if="loader">
        <Loading />
    </div>
    <div v-else>    
        <ContentCompoent :nombreAlerta="null">
            <template #principal>
                <div class="table-responsive">
                    <table class="table">
                        <thead>
                            <tr>
                                <th>Sede</th>
                                <th>Ubicación</th>
                                <th>Acción</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr v-for="sede, index in sedes" :key="index">
                                <td>
                                    <router-link :to="'/bloques/' + sede.nombre+ '/' + sede.id">{{ sede.nombre }}</router-link>
                                </td>
                                <td>{{ sede.direccion }}</td>
                                <td></td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </template>
        </ContentCompoent>
    </div>
</template>
<script>
    import axios from 'axios';
    import Loading from '@/components/Loader/Loading.vue';
    import ContentCompoent from '@/components/Content/Index.vue'
    export default {
        components: {
            ContentCompoent, Loading
        },
        data(){
            return{
                loader: true,
                sedes: []
            }
        },
        mounted() {            
            this.getSedes()
        },
        methods: {
            getSedes(){
                axios.get('/api/sedes', {
                    headers: {
						"Authorization": `Bearer ${this.$store.state.user.token}`
					}
                })
                .then(res => {
                    // console.log(res.data)
                    this.sedes = res.data.sedes;
                    this.loader = false;
                })
                .catch(err => {
                    this.loader = false;
                    console.log(err);
                })
            }
        },
    }
</script>